import React from 'react';
import { Outlet } from 'react-router-dom';
import MainHeader from '../components/MainHeader';
import MainFooter from '../components/MainFooter';

function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col">
      <MainHeader />
      <main className="flex-grow">
        {children || <Outlet />}
      </main>
      <MainFooter />
    </div>
  );
}

export default MainLayout;
